import { constants } from "@newsela/angelou";

const { colors } = constants;

const darkBlue = colors.ui.core[700];

export const buttonWrapperCss = {
  width: "60px",
};

export const buttonCss = {
  "&&": {
    height: "35px",
    width: "100%",
    padding: "8px 8px",
    margin: 0,
  },

  "span, span > svg": {
    margin: 0,
    path: {
      strokeWidth: "4px",
    },
    "span:first-of-type svg >*": {
      stroke: darkBlue,
    },
  },
};

export const popOutCss = {
  right: "1rem",
};
